// generateArticlesEnergyPlus.ts
import dayjs from "dayjs";
export function generateArticlesEnergyPlus({
  member_info,
  ListFrais,
  memberSubscription,
  PrixAassurance,
  ListTransactions,
  TotalsByPaymentMethod,
  active_subscription,
  memberServicesCredits,
}: {
  member_info: any;
  ListFrais: any[];
  memberSubscription: any[];
  PrixAassurance: string;
  ListTransactions: any[];
  TotalsByPaymentMethod: Record<string, number | string>;
  active_subscription: any;
  memberServicesCredits: any[];
}) {
  return {
    firstArticles: [
      {
        type: "article",
        title: "",
        description: `Après la visite des installations et du matériel du club, l’adhérent a pris connaissance du règlement intérieur et des offerts et avant la signature du présent contrat d’abonnement il a été convenu ce qui suit.`,
      },
      {
        type: "article",
        title: "1 - OBJET DU CONTRAT",
        description: `Le présent contrat d’abonnement pour objet la souscription d’un abonnement donnant droit à l’adhérent d’utiliser les installations en libre-service avec accès illimité aux jours et heures d’ouverture du club (Lundi au vendredi 7am -11pm, samedi 08am-08pm, Dimanche 09am-6pm) dans le cadre du forfait de base comprenant : cardio-training, musculation, zone performance, combat zone et studio cycling, selon un prix et des facilités financières indiques dans le présent contrat.`,
      },
      {
        type: "article",
        title: "2 - DROITS D’INSCRIPTION",
        description: `A la signature du présent contrat, l’adhérent s’acquitte par toutes modalités de règlement définies ci-après.`,
        table: {
          headers: ["Les frais", "Montant TTC"],
          data: ListFrais,
        },
      },
      {
        type: "article",
        description: `Le présent contrat d’abonnement est accepté selon les conditions particulières ci-dessous définies et les conditions générales figurant au verso.`,
      },
      {
        type: "article",
        title: "3 - CHOIX DE L’ABONNEMENT",
        subtitle:
          "(avec engagement pour une durée minimale incompressible de 12 mois)",
        description: `Le présent contrat d’abonnement est accepté selon les conditions particulières ci-dessous définies et les conditions générales figurant au verso.`,
        table: {
          headers: [
            "Durée",
            "Pack",
            "Date de début",
            "Date de fin",
            "Prix du pack",
            "Remise et promo",
            "Total Services",
            "Montant TTC",
          ],
          data: memberSubscription,
        },
      },

      // {
      //   type: "article",
      //   description: `Le présent contrat d’abonnement est conclu pour une durée minimale incompressible de 12 mois ou de 24 mois`,
      // },
      // {
      //   type: "article",
      //   title: "4 - ASSURANCE PREMIUM",
      //   priceTitle: PrixAassurance,
      //   description: `N° de police d’assurance : 278 2024 3 00957`,
      // },
      {
        type: "article",
        title: "4 - MODALITÉS DE RÈGLEMENT",
        description: `SOIT UN MONTANT TOTAL A REGLER DE :`,
        priceDesc: active_subscription?.total_amount?.toFixed(2) + " DH",
        table: {
          headers: ["Libellé", "Date de paiement", "Montant payé (DH)"],
          data: ListTransactions,
        },
      },
      {
        type: "article",
        description: `Pour la durée incompressible de l’abonnement, de 12 mois`,
        descriptionColor: "red",
      },
      {
        type: "article",
        description: `L’abonnement est payable selon le mode suivant :`,
      },
      {
        type: "article",
        description: `Espèces :`,
        priceDesc: `${TotalsByPaymentMethod["Espèce"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `Virement/TPE :`,
        priceDesc: `${TotalsByPaymentMethod["Virement/TPE"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `Chèque bancaire :`,
        priceDesc: `${TotalsByPaymentMethod["Chèque bancaire"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description:
          `RESTE : ` +
          active_subscription?.remaining_amount?.toFixed(2) +
          " DH",
        descriptioBold: "bold",
      },

      {
        type: "article",
        description: `L’adhérent reconnait en signant ci-dessous, avoir pris connaissance des conditions Générales au verso et les accepter sans réserve. `,
        descriptioBold: "bold",
      },
    ],

    generalArticles: [
      {
        type: "article",
        description: `Les conditions générales ci-dessous définissent les relations contractuelles entre le club de remise en forme et l'adhérent signataire. Aucune condition particulière ne pourra, sauf acceptation écrite et formelle du club ou de son représentant, prévaloir contre les conditions générales. Toute condition contraire formulée par l'adhérent sera considérée comme nulle, indépendamment du moment où elle a été portée à sa connaissance..`,
      },
      {
        type: "article",
        title: "Objet du contrat",
        description: `Après avoir visité les installations du club ou pris connaissance des prestations offertes, l'adhérent s'engage à souscrire un contrat d'abonnement nominatif incessible, lui permettant d'accéder au club dans le cadre du forfait choisi, selon le prix et les modalités financières spécifiés dans le présent contrat.`,
      },
      {
        type: "article",
        title: "Définition",
        description: `L'abonnement ou la carte de membre est établi pour une durée déterminée, conformément à la durée souscrite lors de la signature du contrat. Le renouvellement nécessitera la création d'un nouveau contrat. Toutefois, au cas où la salle de sport ne dispose pas des installations réservées à contrôler l’accès des adhérents, elle se contentera, dans un premier temps, d’un système de pointage. `,
      },
      {
        type: "article",
        title: "Tarification",
        description: `Le prix indiqué dans le contrat est exprimé en dirhams constants. Le club se réserve le droit d'actualiser le prix de l'abonnement lors de la souscription d'un nouveau contrat. Toute prestation complémentaire non incluse dans le contrat sera facturée en supplément.`,
      },
      {
        type: "article",
        title: "Conditions d'accès",
        description: `Les membres, munis de leur carte valide et de leur identification faciale, sont autorisés à accéder au club et à participer aux cours selon les horaires affichés. Toute modification (horaires d'été, horaires du Ramadan, fermetures pour travaux, cas de force majeure) sera communiquée aux membres. La direction du club se réserve le droit d'exclure toute personne dont le comportement, l'attitude ou la tenue ne sont pas conformes aux bonnes mœurs, nuisibles aux autres membres, ou contraires au présent contrat ou au règlement intérieur.`,
      },
      {
        type: "article",
        title: "Modalités de transfert / résiliation",
        description: `Le contrat ne peut être ni résilié ni transféré. Cependant, l'adhérent a la possibilité de souscrire à l'option 'transfert', lui permettant d'effectuer un transfert ainsi qu'un mois de report durant l'abonnement en cours. Si l'option n'a pas été souscrite lors de l'adhésion, aucun transfert ni report ne pourra être revendiqué.`,
      },
      {
        type: "article",
        title: "Vestiaires / Dépôt",
        description: `L'adhérent peut utiliser des casiers individuels à fermeture traditionnelle, dont l'utilisation est limitée à la durée de la séance. L'adhérent est tenu d'apporter un cadenas pour fermer son casier. Ce cadenas reste la propriété de l'adhérent. Il est strictement interdit de laisser des affaires personnelles à l'intérieur des casiers après avoir quitté le club, car les cadenas seront coupés sans indemnisation. Les vestiaires ne bénéficient d'aucune surveillance spécifique ; il est donc recommandé de ne pas y entreposer d'objets de valeur.`,
      },
      {
        type: "article",
        title: "Règlement intérieur / Règles de Sécurité et Hygiène",
        description: `L'adhérent s'engage à respecter les conditions générales ainsi que le règlement intérieur, sans restriction ni réserve, et à suivre les consignes suivantes :
• La présence des enfants non-inscrits est interdite dans l'enceinte du club pour des raisons de sécurité.
• Il est interdit de fumer à l'intérieur de l'établissement.
• Un respect total envers le personnel du club est exigé.
• Le port de vêtements et de chaussures de sport spécifiques est obligatoire.
• Chaque adhérent doit apporter sa propre serviette et tout matériel d'hygiène nécessaire durant l'entraînement.
• Le respect des horaires des cours est impératif. Toute personne extérieure bénéficiant d'une invitation ou d'une séance découverte est soumise aux mêmes règles que les adhérents inscrits et doit déposer une pièce d'identité durant sa séance, uniquement sur rendez-vous.`,
      },
      //       {
      //         type: "article",
      //         title: "Règlement du SAUNA, Hygiène et Règles de sécurité",
      //         description: `• Capacité : maximum de 6 personnes simultanément.
      // • Hygiène : une douche et un séchage complets sont requis avant l’entrée.
      // • Équipements : le port d'un maillot de bain et d'une serviette est indispensable ; les chaussures sont interdites.
      // • Durée : séance limitée à 15-20 minutes.
      // • Réglages : ne modifiez pas les réglages du sauna.
      // • Électronique : l'utilisation de téléphones et d'appareils électroniques est interdite.
      // • Comportement : il convient de respecter les autres utilisateurs.
      // • Hydratation : assurez-vous de bien vous hydrater avant et après la séance.
      // • Santé : évitez le sauna si vous souffrez de conditions médicales telles que l’hypertension ou des problèmes cardiaques.`,
      //       },
      {
        type: "article",
        title: "Autorisation d’utiliser le droit à l’image",
        description: `L’adhérent du club de sport peut être amené, dans le cadre de sa participation, à apparaître devant le public, directement ou indirectement, par la reproduction de son image sur tout support visuel ou audiovisuel, afin de promouvoir un service ou un message publicitaire au nom du club. En acceptant cela, l’adhérent autorise la reproduction, la représentation et la diffusion de son image à des fins promotionnelles sur les réseaux sociaux, les supports publicitaires ou tout autre moyen de stockage et de diffusion de données Attestation / Certificat médical / Décharge médicale
        
L'adhérent garantit au club d'avoir été examiné par un médecin et d'être capable de pratiquer une activité sportive, qu'il ne souffre d'aucune blessure, maladie ou handicap, qu'il n'a jamais eu de problèmes cardiaques ou respiratoires et qu'il a pris toutes les précautions nécessaires pour sa santé. Il doit remettre au club, dans les deux jours suivant son adhésion, un certificat médical attestant de son aptitude à la pratique sportive. À défaut, l'adhérent décharge le club de toute réclamation, action juridique, frais ou dépense liés à des blessures ou dommages causés durant la pratique sportive, même en cas de négligence ou de manquement aux responsabilités. L'adhérent accepte d'assumer tous les risques associés à sa participation aux activités sportives du club.`,
      },
      {
        type: "article",
        title: "Assurances",
        description: `Le club est assuré pour les dommages engageant sa responsabilité civile ainsi que celle de son personnel, conformément aux dispositions légales. Cette assurance a pour but de garantir le club contre les conséquences pécuniaires relevant de la force majeure. Un montant forfaitaire de 2000,00 Dhs sera retenu pour la clôture du dossier en cas de force majeure, mentionnant : maladie ou accident grave empêchant le membre d'utiliser les services du club, décès, mutation professionnelle imposée par l'employeur. Une assurance complémentaire peut être souscrite le jour de l'adhésion et ne pourra en aucun cas être contractée postérieurement`,
      },

      {
        type: "article",
        title: "Résiliation à l'initiative du Club",
        description: `L'abonnement peut être résilié de plein droit par le club dans les cas suivants : en cas de fraude dans la constitution du dossier d'abonnement, fausse déclaration, falsification. En cas de fraude dans l'utilisation des outils d'accès au club ou en cas de défaut de paiement, il est précisé qu'un incident de paiement suspend l’accès au club jusqu'à régularisation, sans que les mois de blocage ne soient récupérables. Les paiements se feront auprès du comptoir de commercialisation. En cas d'autres incidents de paiements, l'adhérent devra s'acquitter de sa dette auprès de la société de recouvrement, y compris les frais encourus liés aux dommages causés à autrui dans le cadre de l'exploitation. La responsabilité du club ne pourra être engagée en cas d'accidents résultant d'une inobservation des consignes de sécurité ou d'une utilisation inappropriée des appareils ou autres installations`,
      },
    ],
  };
}
